import React, { useCallback, useState, useEffect, useRef } from 'react';
// import { Button, Alert, CircularProgress, Box } from '@mui/material';
import Typography from '@mui/material/Typography';
import { useAssetReport } from './useAssetReport';
import { AssetReportFilterBar } from './AssetReportFilterBar';
import { AssetReportTable } from './AssetReportTable';
import {  AssetReportFilters, AssetReportRow } from './types';
import { DEFAULT_FILTERS } from './constants';
import { handleTime } from '../../helpers/helperFunctions';
// import { Alert } from '@mui/material';
import { useDispatch } from 'react-redux';
import { saveAssetCSVReport, updateAssetCSVReport } from '../../../redux/actions/AssetReport/assetReport';
import { useNavigate, useParams,useLocation } from 'react-router-dom';
import { getReportByIdForCsv } from '../../../redux/actions/Reports/reports';
import Breadcrumbs from "../../common2/Breadcrumbs";
import { TextBoxLatest } from '../../common/TextBoxLatest/TextBoxLatest';
import { triggerAppAlert } from '../../../redux/actions/SelfServicePortal/ContactAid/ContactAid';
import { addDays, subMonths } from 'date-fns';
const getDefaultValue = () =>{
  const temp:any = DEFAULT_FILTERS;
  temp.startDate = subMonths(new Date(), 1).toISOString().split('T')[0];
  temp.endDate = addDays(new Date(), 0).toISOString().split('T')[0];
  return temp;
}
const AssetsCSVReport: React.FC<{ initialValues?: any }> = ({initialValues}:{initialValues?:any}) => {
  const pageUrl = useLocation();
  const subRoute = pageUrl.pathname.split("/")[1]
  const dispatch = useDispatch();
  const nameRef: any = useRef(null);
  const { rows, loading, error, fetchReport } = useAssetReport();
  const [filters, setFilters] = useState<AssetReportFilters>(initialValues?.filterValue?.filters || getDefaultValue());
  const [columns, setColumns] = useState<AssetReportRow[]>([]);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const navigate = useNavigate();
  const handleFilterChange = useCallback((newFilters: AssetReportFilters) => {
    setFilters(newFilters);
  }, []);

  const handleColumnChange = useCallback((cols: any) => {
    setColumns(cols);
  }, []);

  useEffect(() => {
    if (initialValues && nameRef?.current) {
      nameRef.current.value = initialValues.name;
    }
  }, [initialValues]);
  // Auto-fetch when filters change (debounced)
  useEffect(() => {
    if (isInitialLoad) {
      setIsInitialLoad(false);
      return;
    }

    // const timeoutId = setTimeout(() => {
    handleTime.cancel();
    handleTime.setup(()=>{
      fetchReport(filters);
    },1500);
    // }, 500);

    // return () => clearTimeout(timeoutId);
  }, [filters, fetchReport, isInitialLoad]);

  const saveReport = () => {
    if(!(nameRef?.current?.value && nameRef.current.value.trim() !== "")){
      dispatch(triggerAppAlert("Please enter a valid report name", "warning"));
      return;
    }

    if(initialValues){
      dispatch(updateAssetCSVReport(initialValues.id, nameRef.current.value, {filters,columns:columns.filter((col:any)=>!col.hidden).map((col:any)=>col.field)}, saveReportCB));
    }else{
      dispatch(saveAssetCSVReport(nameRef.current.value, {filters,columns:columns.filter((col:any)=>!col.hidden).map((col:any)=>col.field)}, saveReportCB));
    };
  };
  const saveReportCB = () =>{
    navigate('/AssetsReportList')
  }
  return (
    <div style={{ padding: '16px' }}>
      <Breadcrumbs
          data={[
            {
              title: "Reports Management ",
              path: "/ReportsManagement",
            },
            {
              title: "Asset Reports List",
              path: "/AssetsReportList",
            },
            {
              title: subRoute == "ViewAssetsCSVReport" ? "View Assets CSV Report" : `${initialValues ? "Edit" : "Add"} Assets CSV Report `,
              path: subRoute == "ViewAssetsCSVReport" ? "" : `${initialValues ? "AssetsCSVReport/" + initialValues.id : "AssetsCSVReport"}`,
            },
          ]}
      />

      <AssetReportFilterBar initialValues={initialValues?.filterValue} onFilterChange={handleFilterChange} saveReport={saveReport} />
     {subRoute == "ViewAssetsCSVReport" ? 
     <Typography
        variant="body2"
        className="li-title"
        style={{
        color: "black",
        fontSize: "20px",
        margin:"15px",
        }}
    >
        Report Title - {initialValues?.name}
    </Typography>
     : <TextBoxLatest
        placeholder="Please Enter"
        title={"Title"}
        ref={nameRef}
        isMandotary={true}
      />}
      
      {/* <Box sx={{ my: 2, display: 'flex', justifyContent: 'flex-end' }}>
        <Button 
          variant="contained" 
          onClick={handleManualDownload}
          disabled={loading}
          startIcon={loading && <CircularProgress size={20} />}
        >
          {loading ? 'Loading...' : 'Download CSV'}
        </Button>
      </Box> */}

      {/* {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )} */}
      <hr />
      {/* {!loading &&  */}
        <AssetReportTable handleColumnChange={handleColumnChange} initialValues={initialValues?.filterValue} data={rows} loading={loading} />
       {/* }  */}
    </div>
  );
};

export const EditAssetsCSVReport: React.FC = () => {
  const param = useParams();
  
  const [initialValues, setInitialValues] = useState<any>(undefined);
  useEffect(() => {
    param.id && console.log("Fetch report with id:", param.id);
    if(param.id){
      getReportByIdForCsv(param.id).then((res:any)=>{
        // console.log("Report data:", res);
        const initialValues = {
          ...res,
          filterValue: JSON.parse(res.filterValue),
        };
        initialValues.filterValue.filters.startDate = new Date(initialValues.filterValue.filters.startDate);
        initialValues.filterValue.filters.endDate = new Date(initialValues.filterValue.filters.endDate);
        setInitialValues(initialValues); 
      }).catch((err:any)=>{
        console.log("Error fetching report:", err);
      });
    }
  }, [param.id]);
  return (
    <> 

      {initialValues && 
        <AssetsCSVReport initialValues={initialValues} />
      }
    </>
  );
}

export default AssetsCSVReport;